import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreakpointService } from '../../services/breakpoint.service';
import { CurrentRouteService } from '../../services/current-route.service';
import { ApplicationInfoPanelComponent } from '../application-info-panel/application-info-panel.component';
import { MenuBarComponent } from '../menu-bar/menu-bar.component';
import { getRouteLayout } from '../../models/route.config';

/**
 * Main application shell component.
 * Manages layout visibility (carousel, menu bar, info panel) based on current route and breakpoint.
 */
@Component({
    selector: 'app-main',
    imports: [
        RouterOutlet,
        MenuBarComponent,
        ApplicationInfoPanelComponent,
    ],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent {
    readonly breakpointService = inject(BreakpointService);
    readonly currentRouteService = inject(CurrentRouteService);

    /** Show carousel outlet (route-dependent) */
    showCarouselOutlet = computed((): boolean => {
        const layout = getRouteLayout(this.currentRouteService.currentRoute());
        return layout.hideCarousel !== true;
    });

    /** Show menu bar (breakpoint + route dependent) */
    showMenuBar = computed((): boolean => {
        // Hide on mobile
        if (this.breakpointService.breakpoint() === 'MOBILE') {
            return false;
        }

        // Check route configuration
        const layout = getRouteLayout(this.currentRouteService.currentRoute());
        return layout.hideMenuBar !== true;
    });

    /** Show application info panel (route-dependent) */
    showApplicationInfoPanel = computed((): boolean => {
        const layout = getRouteLayout(this.currentRouteService.currentRoute());
        return layout.hideInfoPanel !== true;
    });
}
